import type { ReactNode } from 'react';

/** Split layout shared by sign-in, sign-up and invitation acceptance. */
export function AuthLayout({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      <main className="flex items-center justify-center px-6 py-12">
        <div className="w-full max-w-sm space-y-8">
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <WhnMark />
              <span className="text-lg font-semibold tracking-tight text-ink">WHNUNIVERSE</span>
            </div>
            <h1 className="text-2xl font-semibold tracking-tight text-ink">{title}</h1>
            <p className="text-sm text-ink-muted">{subtitle}</p>
          </div>
          {children}
          {footer ? <div className="text-sm text-ink-muted">{footer}</div> : null}
        </div>
      </main>

      {/* Decorative panel — hidden from assistive tech and on small screens. */}
      <aside
        aria-hidden="true"
        className="hidden bg-brand lg:flex lg:flex-col lg:justify-between lg:p-12"
      >
        <div />
        <blockquote className="space-y-4 text-white">
          <p className="text-xl font-medium leading-relaxed">
            “Every deal, contact and conversation in one place — and a pipeline you can actually
            forecast from.”
          </p>
          <footer className="text-sm opacity-80">The WHNUNIVERSE team</footer>
        </blockquote>
        <ul className="grid grid-cols-3 gap-4 text-white/90">
          {[
            ['Pipelines', 'Drag-and-drop deal stages'],
            ['Automation', 'Rules that do the busywork'],
            ['Insight', 'Forecasts from real data'],
          ].map(([heading, detail]) => (
            <li key={heading}>
              <p className="text-sm font-semibold">{heading}</p>
              <p className="text-xs opacity-75">{detail}</p>
            </li>
          ))}
        </ul>
      </aside>
    </div>
  );
}

function WhnMark() {
  return (
    <svg viewBox="0 0 32 32" className="size-7" aria-hidden="true">
      <rect width="32" height="32" rx="8" className="fill-brand" />
      <path d="M9 22V10h2.6l7.2 8.2V10H22v12h-2.6L12.2 13.8V22H9z" fill="#fff" />
    </svg>
  );
}
